import { ElementType } from "react";
import { Users, Box, Shirt, Car, MapPin, Map, UserPlus, Tags, Armchair } from "lucide-react";

export interface ScriptBreakdown {
  scene_number: string;
  content: string;
}

export type ElementCategory =
  | "CAST"
  | "PROP"
  | "COSTUME"
  | "VEHICLE"
  | "SET_PROP"
  | "EXTRA"
  | "LOCATION"
  | "SUBLOCATION"
  | "OTHER";
export interface Tag {
  id?: string;
  scene_id?: string | number; // Optional, as it may not be set when creating a new tag
  block_id: string;
  category_id: ElementCategory;
  name: string;
  start_index: number;
  end_index: number;
  quantity?: number;
  look?: string;
  age?: string;
  age_range?: { name: string }[];
  crowd_type?: { name: string }[];
  created_at?: string;
  updated_at?: string;
}

export const CATEGORIES: {
  id: ElementCategory;
  label: string;
  color: string;
  hex: string;
  icon: ElementType;
}[] = [
  { id: "CAST", label: "Cast", color: "#F97316", hex: "#FDBA74", icon: Users },
  { id: "PROP", label: "Prop", color: "#7C3AED", hex: "#C4B5FD", icon: Box },
  { id: "COSTUME", label: "Costume", color: "#DB2777", hex: "#F9A8D4", icon: Shirt },
  { id: "VEHICLE", label: "Vehicle", color: "#2563EB", hex: "#93C5FD", icon: Car },
  { id: "SET_PROP", label: "Set Prop", color: "#92400E", hex: "#FCD34D", icon: Armchair },
  { id: "EXTRA", label: "Extra", color: "#F59E0B", hex: "#FDE68A", icon: UserPlus },
  { id: "LOCATION", label: "Location", color: "#059669", hex: "#6EE7B7", icon: MapPin },
  { id: "SUBLOCATION", label: "Sublocation", color: "#65A30D", hex: "#BEF264", icon: Map },
  // { id: "OTHER", label: "Other", color: "#475569", hex: "#CBD5F5", icon: Tags }
];
